

<div class="modal-header bg-white justify-content-end">
  <a class="link-hover font-weight-light" (click)="close()">
    <i class="fa-regular fa-xmark mr-2" title="Stäng"></i> Stäng
  </a>
</div>

<div class="modal-body">
  <iframe
      [src]="safeUrl"
      style="height: 100%; border-width: 0; width: 100%; display: block; background-color: #fff; opacity: 1;"
      class="iframe vh-100"
      allowtransparency="true"
      frameborder="0"
      scrolling="auto vh-100"
      allowfullscreen>
  </iframe>
</div>
